import { DateTime, Interval } from "luxon";

export const DISPLAY_DATE_FORMAT = "MM/dd/yyyy";
export const DISPLAY_DATE_FORMAT_WITH_TIME = "MM/dd/yyyy HH:mm:ss";
export const API_DATE_FORMAT = "yyyy-MM-dd";

export const getDatePickerFormattedDate = (date: string | Date): string => {
  if (date instanceof Date) {
    return DateTime.fromJSDate(date).toFormat(DISPLAY_DATE_FORMAT);
  }
  return date || "";
};

export const getToday = (format = DISPLAY_DATE_FORMAT) => {
  return DateTime.now().toFormat(format);
};

export const getLuxonDateTime = (value?: string | Date): DateTime | null => {
  if (!value) return null;

  if (typeof value === "string") {
    return DateTime.fromFormat(value, DISPLAY_DATE_FORMAT);
  }

  if (value instanceof Date && DateTime.fromJSDate(value).isValid) {
    return DateTime.fromJSDate(value);
  }
  return null;
};

export const dateToIso = (value: string | Date): string => {
  let date = "";

  if (value && typeof value === "string") {
    const validDate = DateTime.fromFormat(value, DISPLAY_DATE_FORMAT, {
      zone: "GMT",
    }).toISO();
    date = validDate ? validDate : "";
  }

  if (value instanceof Date && DateTime.fromJSDate(value).isValid) {
    date = DateTime.fromJSDate(value, { zone: "GMT" }).toISO();
  }

  return date;
};

export const getApiFormattedDate = (value: string | Date): string => {
  if (typeof value === "string" && value.includes("-")) return value;

  const date =
    typeof value === "string"
      ? DateTime.fromFormat(value, DISPLAY_DATE_FORMAT, { zone: "GMT" })
      : DateTime.fromJSDate(value, { zone: "GMT" });
  return date.toFormat(API_DATE_FORMAT);
};

// Copied from Ascend
export const formatUTCDate = (date?: string | string[]) => {
  if (!date) return getToday();

  if (Array.isArray(date)) {
    return DateTime.fromISO(date[0], { zone: "GMT" }).toFormat(
      DISPLAY_DATE_FORMAT
    );
  }

  return DateTime.fromISO(date, { zone: "GMT" }).toFormat(DISPLAY_DATE_FORMAT);
};

// Copied from Ascend
export function isFirstDateAfterOrEqualToSecondDate(
  firstDate?: string | Date,
  secondDate?: string | Date
) {
  if (!firstDate || !secondDate) return true;
  const startDate = getLuxonDateTime(firstDate);
  const endDate = getLuxonDateTime(secondDate);

  return !(startDate && endDate && startDate < endDate);
}

// Copied from Ascend
export function dateInterval(
  firstDate?: string | Date,
  secondDate?: string | Date
): number | undefined {
  if (!firstDate) return;
  if (!secondDate) return;
  const startDate = getLuxonDateTime(firstDate);
  const endDate = getLuxonDateTime(secondDate);

  if (startDate && endDate && startDate < endDate) {
    const i = Interval.fromDateTimes(startDate, endDate);
    return i.length("days");
  }
  return;
}
